import { render, staticRenderFns } from "./cateredStudentList.vue?vue&type=template&id=0c131332&scoped=true&"
import script from "./cateredStudentList.vue?vue&type=script&lang=js&"
export * from "./cateredStudentList.vue?vue&type=script&lang=js&"
import style0 from "./cateredStudentList.vue?vue&type=style&index=0&id=0c131332&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c131332",
  null
  
)

export default component.exports